import axios from "./HTTP";

export default {
  search(params, callback, errorCallback) {
    axios
      .get("/api/employees/search.json", { params: params })
      .then(response => callback(response.data))
      .catch(error => errorCallback(error));
  },

  deactivate(userID, callback, errorCallback) {
    axios
      .post(`/api/employees/${userID}/deactivate.json`)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  reactivate(userID, callback, errorCallback) {
    axios
      .post(`/api/employees/${userID}/reactivate.json`)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  create(params, callback, errorCallback) {
    axios
      .post(`/api/employees.json`, params)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  getAll(userId, callback) {
    axios
      .get("/api/employees.json", { params: { user_id: userId } }) // but only employees of this user
      .then(response => callback(response.data));
  },

  getInactiveEmployees(userId, callback) {
    axios
      .get("/api/inactive_employees.json", { params: { user_id: userId } })
      .then(response => callback(response.data));
  },

  get(employeeId, callback, errorCallback) {
    axios
      .get(`/api/employees/${employeeId}.json`)
      .then(response => callback(response.data))
      .catch(error => errorCallback(error));
  },

  getCurrent(employeeId, callback) {
    axios
      .get(`/api/employees/${employeeId}/currently.json`)
      .then(response => callback(response.data));
  },

  update(idAndFields, callback, errorCallback) {
    axios
      .patch(`/api/employees/${idAndFields.id}.json`, idAndFields)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  savePhoto(idAndFields, callback, errorCallback) {
    axios
      .patch(`/api/employees/${idAndFields.id}/save_photo.json`, idAndFields)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  saveCertification(idAndFields, callback, errorCallback) {
    axios
      .patch(
        `/api/employees/${idAndFields.id}/save_certification.json`,
        idAndFields
      )
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  addTeam(params, callback, errorCallback) {
    axios
      .post(`/api/employees/${params.id}/add_teams.json`, params)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  setEmployeeProfilePreferences(params, callback, errorCallback) {
    axios
      .patch(`/api/employees/${params.id}/profile.json`, params)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  managerOverrideMessagePreferences(params, callback, errorCallback) {
    axios
      .patch(`/api/employees/${params.id}/profile.json`, params)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  pullOffTeam(params, callback, errorCallback) {
    axios
      .patch(`/api/employees/${params.id}/remove_teams.json`, params)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  removeIneligibleTeam(params, callback, errorCallback) {
    axios
      .patch(`/api/employees/${params.id}/remove_ineligible_teams.json`, params)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  addIneligibleTeam(params, callback, errorCallback) {
    axios
      .post(`/api/employees/${params.id}/add_ineligible_teams.json`, params)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  saveNarrativeNotes(params, callback, errorCallback) {
    // const notes = params.narrative_notes;
    axios
      .patch(`/api/employees/${params.id}/save_narrative_notes.json`, params)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  addSkill(idSkill, callback, errorCallback) {
    axios
      .patch(`/api/employees/${idSkill.id}/add_skill.json`, idSkill)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },
  removeSkill(idSkill, callback, errorCallback) {
    axios
      .patch(`/api/employees/${idSkill.id}/remove_skill.json`, idSkill)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  removeERContact(contactID, callback, errorCallback) {
    axios
      .delete(`/api/emergency_contacts/${contactID}.json`)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  addRemoveSkill(idSkillPresent, callback, errorCallback) {
    axios
      .patch(`/api/employees/${idSkillPresent.id}/skills.json`, idSkillPresent)
      .then(response => {});
  },

  getManagers(userID, callback, errorCallback) {
    axios
      .get(`/api/managers.json`, { params: { for_user_id: userID } })
      .then(response => callback(response.data));
  },

  getPrimaryPositions(userID, callback, errorCallback) {
    axios
      .get(`/api/employee_positions.json`, { params: { for_user_id: userID } })
      .then(response => callback(response.data));
  },

  getSMSAble(callback, errorCallback) {
    axios
      .get(`/api/sms/recipient_employees.json`)
      .then(r => {
        callback(r);
      })
      .catch(e => {
        errorCallback(e);
      });
  },

  getReviews(params, callback, errorCallback) {
    axios
      .get(`/api/user_reviews.json`, {
        params: {
          recipient_id: params.recipientId
        }
      })
      .then(response => callback(response.data))
      .catch(err => errorCallback(err));
  },

  createReview(params, callback, errorCallback) {
    axios
      .post(`/api/user_reviews.json`, {
        user_review: {
          recipient_id: params.recipientId,
          author_id: params.authorId,
          date_of_review: params.dateOfReview,
          review: params.review,
          annual_review: params.annualReview,
          review_type: params.reviewType,
          upload: params.uploadData
        }
      })
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  updateReview(idAndFields, callback, errorCallback) {
    axios
      .patch(`/api/user_reviews/${idAndFields.id}.json`, idAndFields)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  }
};
